import { render, staticRenderFns } from "./ListaArchivos.vue?vue&type=template&id=1932d2cb"
import script from "./ListaArchivos.vue?vue&type=script&lang=js"
export * from "./ListaArchivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports